import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Widget from "./Widget";
import useTicketingWidget from "../../hooks/useTicketingWidget";

dayjs?.extend(customParseFormat);

const TicketingMain = ({ widgetSetupId, floating, widgetpos }) => {
  const {
    combinationLoading,
    isOpenWidget,
    widgetConfig,
    dispatch,
    openWidget,
    setOpenWidget,
    getWidgetPositionStyle,
    send,
    widgetLoading,
    langLoading,
    theme,
    handleClose,
    buttonText,
    eventStdTicketLoader,
    loader,
  } = useTicketingWidget();

  const hasImage            = Boolean(widgetConfig?.settings?.imageFileName?.trim());
  const configuredImgHeight = widgetConfig?.settings?.imageHeight;
  const [dynamicHeight, setDynamicHeight] = useState(undefined);

  const handleHeightChange = (heightPx) => {
    if (!hasImage) setDynamicHeight(heightPx);
  };

  const iframeHeight = hasImage
    ? configuredImgHeight ? `${configuredImgHeight}px` : "100vh"
    : dynamicHeight ?? "100vh";

  if (widgetLoading || langLoading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={widgetLoading || langLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (widgetConfig?.settings?.kioskMode) {
    return (
      <Box sx={{ width: "100%", minHeight: "100vh" }}>
        <Widget
          heightChange={handleHeightChange}
          handleClose={() => setOpenWidget((prev) => !prev)}
          loading={combinationLoading}
          widgetpos={widgetpos}
          eventStdTicketLoader={eventStdTicketLoader}
          loader={loader}
        />
      </Box>
    );
  }

  return (
    <>
      {send(iframeHeight, "100%", "", "0px", "0px", "", floating)}
      <Box
        sx={{
          width: "100%",
          height: iframeHeight,
          position: "relative",
          overflow: "visible",
        }}
      >
        <Widget
          heightChange={handleHeightChange}
          handleClose={() => setOpenWidget((prev) => !prev)}
          loading={combinationLoading}
          widgetpos={widgetpos}
          eventStdTicketLoader={eventStdTicketLoader}
          loader={loader}
        />
      </Box>
    </>
  );
};

export default TicketingMain;